import React from 'react';
import { motion } from 'framer-motion';
export function VideoSection() {
  return <section className="py-20 bg-[#FAF9F7]" data-id="element-294">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-295">
        <div className="text-center mb-12" data-id="element-296">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-bold text-[#800000] font-serif" data-id="element-297">
            MT²RL at a Glance
          </motion.h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative w-full max-w-4xl mx-auto rounded-2xl overflow-hidden shadow-2xl bg-black aspect-video" data-id="element-298">
          {/* Note to user: Replace the src URL below with your actual YouTube embed URL */}
          <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/dQw4w9WgXcQ?rel=0" title="MT2RL Laboratory Overview" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen data-id="element-299"></iframe>
        </motion.div>
      </div>
    </section>;
}